<template>
  <div class="multioptions">
    <div
      :class="[{'Form--field--error': (vuelidateElement && vuelidateElement.$error) || ( manualErrorFlag)},
      containerClass]"
      v-focus-input
    >
      <date-picker-input
        v-if="type==='date'"
        :mode="isPlexus ? 'date' : 'dateTime'"
        :placeholder="placeholder"
        :value="fieldValue"
        :disabled="disabled"
        parentFormField
        @inputDate="setExpenseDate($event)"
        @hide="vuelidateElement.$touch()"
      ></date-picker-input>
      <input
        v-if="type === 'normal'"
        type="text"
        class="Input-text"
        :value="fieldValue"
        :disabled="disabled"
        :placeholder="placeholder"
        @change="handleValue"
        @input="handleValue"
        @blur="touchElement"
      />
      <currency-input
        v-if="type === 'money'"
        :class="inputClass"
        :value="fieldValue"
        :currency="null"
        :disabled="disabled"
        :placeholder="placeholder"
        :allow-negative="false"
        @input="handleValue"
        @blur="emitBlur"
      >
      </currency-input>
      <div
        v-if="options && options.length > 0"
        class="icon-multioptions"
        v-on-clickaway="handleClickAway"
        @click.stop="openOptions"
      >
        <i
          class="Ctrl Ctrl--16"
          aria-hidden="true"
        >
          <img
            alt="'icon-multioptions-selector''"
            :src="require('@/assets/img/icons/icon-multioptions-text.svg')"
          />
        </i>
      </div>
      <div
        v-if="options && options.length > 0"
        v-show="opened"
        class="multiselect__content-wrapper"
      >
        <ul class="multiselect__content">
          <li
            v-for="option in options"
            :key="option.id"
            class="multiselect__element"
          >
            <p class="option-group">
              {{option.number}}
            </p>
            <p
              class="option-item"
              :class="{'multiselect__option--selected': value === option.item}"
              @click="selectOption(option.item)"
            >
              <span v-if="type === 'date'">{{$moment(option.item).format('DD/MM/YYYY HH:mm')}}</span>
              <span v-else>{{option.item}}</span>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { CurrencyInput } from 'vue-currency-input'
import DatePickerInput from '@/components/Commons/Forms/DatePickerInput'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'MultioptionsText',
  components: {
    CurrencyInput,
    DatePickerInput
  },
  mixins: [clickaway],
  data () {
    return {
      value: null,
      opened: false
    }
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    fieldValue: {
      required: true
    },
    vuelidateElement: {
      default: () => { }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    money: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    field: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'normal'
    },
    isPlexus: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: String,
      default: 'Input-text'
    },
    containerClass: {
      type: String,
      default: 'Form-field'
    },
    manualErrorFlag: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setExpenseDate (date) {
      this.$emit('inputDate', date)
    },
    touchElement () {
      if (this.vuelidateElement && this.vuelidateElement.$touch) {
        this.vuelidateElement.$touch()
      }
    },
    handleClickAway () {
      this.opened = false
    },
    openOptions () {
      this.opened = !this.opened
    },
    closeOptions () {
      this.opened = false
    },
    handleValue (event) {
      if (this.money) {
        this.$emit('update:fieldValue', Number(event))
        this.$emit('updatedValue', Number(event))
      } else {
        this.$emit('update:fieldValue', event.target.value)
        this.$emit('updatedValue', event.target.value)
      }
    },
    selectOption (event) {
      this.opened = false
      this.$emit('update:fieldValue', event)
      this.$emit('updatedValue', event)
    },
    emitBlur () {
      this.$emit('blur')
    }
  }
}
</script>
<style lang="scss" scoped>
.Form-field {
  position: relative;
  .icon-multioptions {
    position: absolute;
    right: 16px;
    top: 14px;
  }
}
.option-group {
  font-weight: 500;
  font-size: 9px;
  line-height: 11px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--text-heading);
  padding: 0 12px 0;
  margin-bottom: 2px;
}
.option-item {
  padding: 6px 12px;
  margin: 0;
  margin-bottom: 6px;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  color: var(--text-body);
}
.multiselect__content-wrapper {
  top: 46px;
  left: 0;
}
.multiselect__content:has(.option-group) {
  padding: 12px 0 6px;
  .multiselect__element {
    .option-item {
      cursor: pointer;
      &:hover {
        background: var(--fill-hover) !important;
        outline: none;
      }
    }
  }
}
.multiselect__option--selected {
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: 10px;
    right: 0;
    width: 20px;
    height: 20px;
    background-image: url("~@/assets/img/icons/icon-tag-option-selected.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-color: transparent;
    line-height: 40px;
    padding-right: 12px;
    padding-left: 20px;
  }
}
.Form--field--error {
  border: 2px solid var(--semantic-negative-main);
}
</style>
